<template>
  <v-layout justify-center align-center class="bg__register py-12">
    <v-flex xs10 sm7 md6 lg5>
      <Topic eng="Register" thai="สมัครสมาชิก" />

      <!-- form -->
      <v-form
        ref="form"
        class="mt-12 register__form"
        v-model="valid"
        lazy-validation
      >
        <div class="mt-2">
          <label class="font-18 font-w-500">
            <span class="valid">*</span>คำนำหน้า
          </label>
          <v-text-field
            v-model="form.title"
            outlined
            dense
            placeholder="ระบุคำนำหน้า"
            :rules="[(v) => !!v || 'ระบุคำนำหน้า']"
          />
        </div>

        <v-row class="mt-2">
          <v-col cols="12" sm="6" class="py-0">
            <label class="font-18 font-w-500">
              <span class="valid">*</span>ชื่อ
            </label>
            <v-text-field
              v-model="form.first_name"
              outlined
              dense
              placeholder="ระบุชื่อ"
              :rules="[(v) => !!v || 'ระบุชื่อ']"
            />
          </v-col>
          <v-col cols="12" sm="6" class="py-0">
            <label class="font-18 font-w-500">
              <span class="valid">*</span>สกุล
            </label>
            <v-text-field
              v-model="form.last_name"
              outlined
              dense
              placeholder="ระบุสกุล"
              :rules="[(v) => !!v || 'ระบุสกุล']"
            />
          </v-col>
        </v-row>

        <div class="mt-2">
          <label class="font-18 font-w-500">
            <span class="valid">*</span>วิชาชีพ
          </label>
          <v-autocomplete
            v-model="form.profession"
            :items="profession_list"
            outlined
            dense
            item-text="title"
            item-value="id"
            placeholder="ระบุวิชาชีพ"
            :rules="[(v) => !!v || 'ระบุวิชาชีพ']"
          ></v-autocomplete>
          <v-text-field
            v-if="form.profession === 14"
            class="mt-0"
            v-model="form.profession_other"
            outlined
            dense
            placeholder="ระบุวิชาชีพอื่นๆ"
            :rules="[
              ((v) => !!v && form.profession === 14) || 'ระบุวิชาชีพอื่นๆ',
            ]"
          />
        </div>

        <div class="mt-0">
          <label class="font-18 font-w-500">
            <span class="valid">*</span>สังกัด
          </label>
          <v-autocomplete
            v-model="form.institution"
            :items="institution_list"
            outlined
            dense
            item-text="title"
            item-value="id"
            placeholder="ระบุสังกัด"
            :rules="[(v) => !!v || 'ระบุสังกัด']"
          ></v-autocomplete>

          <v-text-field
            v-if="form.institution === 7"
            class="mt-0"
            v-model="form.institution_other"
            outlined
            dense
            placeholder="ระบุสังกัดอื่นๆ"
            :rules="[
              ((v) => !!v && form.institution === 7) || 'ระบุสังกัดอื่นๆ',
            ]"
          />
        </div>

        <div class="mt-0">
          <label class="font-18 font-w-500">
            <span class="valid">*</span>ชื่อหน่วยงาน
          </label>
          <v-text-field
            outlined
            dense
            v-model="form.institution_description"
            :rules="[(v) => !!v || 'ระบุชื่อหน่วยงาน']"
            placeholder="ระบุชื่อหน่วยงาน"
          />
        </div>

        <div class="mt-0">
          <v-col cols="12" class="px-0 pt-0">
            <label class="font-18 font-w-500">
            <span class="valid">*</span>ที่ตั้งหน่วยงาน
          </label>
          </v-col>
        </div>

        <v-row class="mt-0">
          <v-col cols="12" sm="6" class="py-0">
            <label class="font-18 font-w-500">
              <span class="valid">*</span>จังหวัด
            </label>
            <v-autocomplete
              v-model="selectedProvince"
              :items="provinces"
              outlined
              dense
              item-text="name_th"
              item-value="province_id"
              @change="fetchDistricts"
              placeholder="ระบุจังหวัด"
              :rules="[(v) => !!v || 'ระบุจังหวัด']"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="6" class="py-0">
            <label class="font-18 font-w-500">
              <span class="valid">*</span>อำเภอ
            </label>
            <v-autocomplete
              v-model="selectedDistrict"
              :items="districts"
              outlined
              dense
              item-text="name_th"
              item-value="district_id"
              :disabled="!selectedProvince"
              @change="fetchSubdistricts"
              placeholder="ระบุอำเภอ"
              :rules="[(v) => !!v || 'ระบุอำเภอ']"
            ></v-autocomplete>
          </v-col>
         
        </v-row>
        
        <v-row class="mt-0">
          <v-col cols="12" sm="6">
            <label class="font-18 font-w-500">
              <span class="valid">*</span>ตำบล
            </label>
            <v-autocomplete
              v-model="selectedSubdistrict"
              :items="subdistricts"
              outlined
              dense
              item-text="name_th"
              item-value="subdistrict_id"
              :disabled="!selectedDistrict"
              @change="updateZipcode"
              placeholder="ระบุตำบล"
              :rules="[(v) => !!v || 'ระบุตำบล']"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6">
            <label class="font-18 font-w-500">
              <span class="valid">*</span>เลขไปรษณีย์
            </label>
            <v-text-field
              type="number"
              v-model="zipcode"
              outlined
              dense
              placeholder="ระบุเลขไปรษณีย์"
              :rules="[
              (v) => !!v || 'ระบุเลขไปรษณีย์',
              (v) => (v && v.length == 5) || 'ระบุเลขไปรษณีย์ 5 ตัว',
              ]"
            />
          </v-col>
        </v-row>

        <v-row class="mt-0">
          <v-col cols="12" sm="6" class="py-0">
            <label class="font-18 font-w-500">
              <span class="valid">*</span>เบอร์โทรศัพท์
            </label>
            <v-text-field
              v-model="form.mobile_phone"
              :oninput="returnInputRule"
              outlined
              dense
              placeholder="ระบุเบอร์โทรศัพท์"
              :rules="[
                (v) => !!v || 'ระบุเบอร์โทรศัพท์',
                (v) =>
                  (v && v.length == 10) || 'รหัสผ่านต้องมีความยาว 10 ตัวอักษร',
              ]"
            />
          </v-col>
          <v-col cols="12" sm="6" class="py-0">
            <label class="font-18 font-w-500">
              <span class="valid">*</span>อีเมล
            </label>
            <v-text-field
              v-model="form.email"
              outlined
              dense
              type="email"
              placeholder="ระบุอีเมล"
              :rules="[
                (v) => !!v || 'ระบุอีเมล',
                (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
              ]"
            />
          </v-col>
        </v-row>

        <div class="mt-4 input__password">
          <label for="password" class="font-18 font-w-500">
            <span class="valid">*</span>รหัสผ่าน
            <p style="color: #FF7070" class="font-1">
              (รหัสผ่านต้องประกอบด้วยตัวเลขและตัวอักษรเท่านั้น อย่างน้อย 6 ตัว)
            </p>
          </label>
          <v-text-field
            v-model="form.password"
            outlined
            type="password"
            dense
            placeholder="ระบุรหัสผ่าน"
            :rules="[
              (v) => !!v || 'ระบุรหัสผ่าน',
              (v) => (v && v.length >= 6) || 'กรอกรหัสผ่านอย่างน้อย 6 ตัว',
              (v) => /\d/.test(v) || 'รหัสผ่านต้องประกอบด้วยตัวเลขและตัวอักษรเท่านั้น',
              (v) => /[a-zA-Z]/.test(v) || 'รหัสผ่านต้องประกอบด้วยตัวเลขและตัวอักษรเท่านั้น',
            ]"
          />
        </div>

        <div class="mt-12 d-flex justify-center">
          <v-btn
            class="btn__login"
            :disabled="!valid"
            :dark="valid"
            @click="validate"
            height="58px"
          >
            <span class="font-24 font-w-500">สมัครสมาชิก</span>
          </v-btn>
        </div>

        <div class="mt-4 text-center font-24 font-w-500" style="color: #4090ff">
          <span class="hover__underline" @click="$router.push('/login')">
            ย้อนกลับ
          </span>
        </div>
      </v-form>

      <Loading :loading="isLoading"></Loading>
    </v-flex>
  </v-layout>
</template>

<script>
import Topic from "../../components/Topic.vue";
import { domain } from "../../util/Constant";
import Axios from "axios";
import Loading from "../../components/Loading.vue";
export default {
  components: { Topic, Loading },

  data() {
    return {
      valid: true,
      isLoading: false,
      form: {
        title: "",
        first_name: "",
        last_name: "",
        profession: "",
        profession_other: "",
        institution: "",
        institution_other: "",
        institution_description: "",
        mobile_phone: "",
        email: "",
        password: "",
        province_id: "",
        district_id: "",
        subdistrict_id: "",
        zipcode: "",
      },
      profession_list: [],
      institution_list: [],
      provinces: [],
      districts: [],
      subdistricts: []
    };
  },
  computed: {
    returnInputRule: function () {
      return "value=value.replace(/[^\\d]/g,'')";
    }
  },
  async created() {
    // call api
    this.isLoading = true;
    const { data } = await Axios.get(`${domain}/list-register`);
    this.profession_list = await data.professions;
    this.institution_list = await data.institutions;
    this.isLoading = false;
    this.valid = false;
    
    this.fetchProvinces();
  },
  methods: {
    // ดึงข้อมูลจังหวัด
    async fetchProvinces() {
      try {
        const response = await Axios.get(`${domain}/province`);
        this.provinces = response.data;
      } catch (error) {
        console.error("Error fetching provinces:", error);
      }
    },

    // ดึงข้อมูลอำเภอตามจังหวัดที่เลือก
    async fetchDistricts() {
      this.selectedDistrict = null;
      this.selectedSubdistrict = null;
      this.districts = [];
      this.zipcode = "";

      if (!this.selectedProvince) return;

      try {
        const response = await Axios.get(`${domain}/district?province_id=${this.selectedProvince}`);
        this.districts = response.data;
      } catch (error) {
        console.error("Error fetching districts:", error);
      }
    },

    // ดึงข้อมูลตำบลตามอำเภอที่เลือก
    async fetchSubdistricts() {
      this.selectedSubdistrict = null;
      this.subdistricts = [];
      this.zipcode = "";

      if (!this.selectedDistrict) return;

      try {
        const response = await Axios.get(`${domain}/subdistrict?district_id=${this.selectedDistrict}`);
        this.subdistricts = response.data;
      } catch (error) {
        console.error("Error fetching subdistricts:", error);
      }
    },
    // อัปเดตรหัสไปรษณีย์
    updateZipcode() {
      const subdistrict = this.subdistricts.find(s => s.subdistrict_id === this.selectedSubdistrict);
      this.zipcode = subdistrict ? subdistrict.zipcode : "";
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;

        this.form.province_id = this.selectedProvince;
        this.form.district_id = this.selectedDistrict;
        this.form.subdistrict_id = this.selectedSubdistrict;
        this.form.zipcode = this.zipcode;



        Axios.post(`${domain}/register`, this.form)
          .then(() => {
            this.$swal({
              title: "สมัครสมาชิกเรียบร้อย",
              text: "เจ้าหน้าที่จะส่งข้อความยืนยัน การอนุมัติการเป็นสมาชิกไปที่อีเมลของท่าน ภายใน 3 วันทำการ",
              icon: "success",
              confirmButtonText: "ตกลง",
            }).then(() => {
              this.$router.push("/login");
            });
            this.isLoading = false;
          })
          .catch((e) => {
            this.isLoading = false;
            this.$swal({
              title: "สมัครสมาชิกไม่สำเร็จ",
              text: e.response.data.message,
              icon: "error",
            });
          });
      }else{
        this.valid = false;
      }
    },
  },
};
</script>

<style lang="scss">
.bg__register {
  background: linear-gradient(180deg, #ffffff 0%, #edf0f6 100%);
  min-height: calc(100vh - 136px);
  color: #5e616f;
}
.register__form {
  .v-text-field.v-text-field--enclosed .v-text-field__details {
    padding-top: 0px;
    margin-bottom: 0px !important;
  }
}

.btn__login {
  width: 342px;
  background: linear-gradient(
    91.81deg,
    #4950ec -14.83%,
    #4090ff 48.24%,
    #6dcdec 107.49%
  );
  border-radius: 30px;
}
.forgot__pass {
  color: #bcc4cb;
  cursor: pointer;
}
.forgot__pass a:hover {
  text-decoration: underline;
}
.input__password {
  .theme--light.v-input input,
  .theme--light.v-input textarea {
    color: #4090ff;
  }
}
.valid {
  color: red;
}
</style>
